<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">For our daughter, Melissa	v</span></p>
<p class="dedication" lang="en-US"><span class="Italic-Style" lang="en-US">who has Nanny’s eyes	v</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 97815040844061.vue?44696722